import { format } from 'date-fns'

export function dateParse(date: Date | string | number, timeFormat = 'HH:mm:ss - d/M/yy') {
  let dateObj = new Date(date)
  if (!isValidDate(dateObj)) {
    dateObj = new Date(+date)
  }
  return format(dateObj, timeFormat)
}

export function dateParseChat(
  date: Date | string | number,
  options = { timeFormat: 'MMM dd, yyyy', checkToday: true }
) {
  if (!date) {
    return
  }
  const { timeFormat, checkToday } = options
  let dateObj = new Date(date)
  if (!isValidDate(dateObj)) {
    dateObj = new Date(+date)
  }
  if (!checkToday) {
    return format(dateObj, '')
  }
  return format(dateObj, timeFormat)
}

export function isValidDate(d: any) {
  return d instanceof Date && !isNaN(+d)
}
